import React, { useContext } from 'react';

import Grid from '@mui/material/Grid';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import FlaggedDevicesSubList from '../components/FlaggedDevicesSubList';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../../sharedModules/layout/PageHeader';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

import { useFlaggedDevices } from '../hooks/useFlaggedDevices';

const FlaggedDevicesListPage: React.FunctionComponent = () => {
  const { user } = useContext(AuthenticationContext);

  const { data, isLoading, isError, refetch } = useFlaggedDevices({ enabled: !!user });

  const allFlaggedDevices = data?.data?.result ?? [];

  const outOfServiceDevices = allFlaggedDevices.filter((d) => d.status === 'out_of_service');

  // All devices that were not included in the first group.
  // Theoretically, this should only include newly-created devices.
  // But this is written to catch discrepancies
  const newDevices = allFlaggedDevices.filter((d) => !outOfServiceDevices.some((o) => o.id === d.id));

  return (
    <Grid container>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={isLoading}>
          <Grid container>
            <Grid item xs={12} style={{ marginBottom: 20 }}>
              <PageHeader mainTitle="Backflow Testing" subTitle="Flagged Devices" />
            </Grid>
            <Grid item xs={12}>
              <ErrorMessage message={isError ? 'Something went wrong fetching the Devices' : null} />
            </Grid>
            <Grid item xs={12}>
              <FlaggedDevicesSubList
                jobItemsSubList={outOfServiceDevices}
                afterComplete={refetch}
                title="Out of Service"
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 20 }}>
              <FlaggedDevicesSubList
                jobItemsSubList={newDevices}
                afterComplete={refetch}
                title="Newly-Added"
              />
            </Grid>
          </Grid>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

export default FlaggedDevicesListPage;
